function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 9.558a9.5 9.5 0 10-19 0c0 4.742 3.474 8.672 8.016 9.385v-6.639H5.604V9.558h2.412V7.465c0-2.38 1.418-3.696 3.588-3.696 1.039 0 2.127.186 2.127.186v2.337h-1.198c-1.18 0-1.549.733-1.549 1.485v1.781h2.635l-.421 2.746h-2.214v6.639C15.526 18.23 19 14.3 19 9.558z",
  fill: "#fff"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFacebook;